import { CmsVendor, IntegrationFeatures } from "@modules/graphql/types"

type CmsVendorsWithConfigs =
  | CmsVendor.Contentful
  | CmsVendor.Datocms
  | CmsVendor.Cosmicjs
  | CmsVendor.Sanity

type CmsConfig = { [key in CmsVendorsWithConfigs]?: { [key: string]: string } }

export type FormatCmsConfigurationOpts = {
  config?: { [key: string]: any } & { managementUrl?: string }
  features?: IntegrationFeatures | null
  vendor?: CmsVendor
}

type CmsConfigurationRow = {
  name: string
  value: string | boolean
  url?: string
}

const CMS_CONFIG: CmsConfig = {
  [CmsVendor.Contentful]: {
    spaceName: `Space`,
    spaceId: `Space Id`,
    url: `spaceName`,
  },
  [CmsVendor.Datocms]: {
    projectName: `Project`,
    projectId: `Project Id`,
    url: `projectName`,
  },
  [CmsVendor.Cosmicjs]: {
    bucketSlugName: `Bucket`,
    bucketSlugId: `Bucket Id`,
    url: `bucketSlugName`,
  },
  [CmsVendor.Sanity]: {
    projectId: `Project ID`,
    projectName: `Project Name`,
    dataset: `Dataset`,
    url: `projectName`,
  },
}

export const formatCmsConfiguration = ({
  config,
  features,
  vendor,
}: FormatCmsConfigurationOpts): CmsConfigurationRow[] => {
  const cmsConfig = []
  const vendorConf = CMS_CONFIG[vendor as CmsVendorsWithConfigs]

  if (config && vendorConf) {
    Object.entries(config).forEach(([key, value]) => {
      if (vendorConf[key]) {
        const configUrl = vendorConf[`url`] === key && {
          url: config?.managementUrl || ``,
        }

        const cmsObj = {
          name: vendorConf[key],
          value,
          ...configUrl,
        }

        if (configUrl) cmsConfig.unshift(cmsObj)
        else cmsConfig.push(cmsObj)
      }
    })
  }

  if (features) {
    cmsConfig.push(
      {
        name: `Build Webhook`,
        value: !!features?.webhooks,
      },
      {
        name: `Environment Variables`,
        value: !!features?.envVars,
      },
      {
        name: `Preview Extension`,
        value: !!features?.extension,
      }
    )
  }

  return cmsConfig
}
